module.exports = __webpack_public_path__ + "static/media/24.541adf5f.jpg";